/**
 * MCMN Experience Hero - Starry Night Sky Effect
 * Generates twinkling stars and applies light effects
 */

(function (Drupal, once) {
  'use strict';

  Drupal.behaviors.mcmnExperienceHero = {
    attach: function (context, settings) {
      if (document.querySelector(".page-mi-casa-mi-navidad")) {
        once('mcmn-experience-hero', '.chapter-carousel, .mcmn-experience, .mcmn-book-gated, .flip-cards, .mcmn-experience-hero, .staff', context).forEach(function (hero) {
          // Only generate stars if they haven't been generated yet
          if (hero.querySelector('.star1')) {
            return;
          }
  
          // Create a dedicated star container that won't be affected by Slick
          const starContainer = document.createElement('div');
          starContainer.classList.add('mcmn-stars-container');
          starContainer.style.position = 'absolute';
          starContainer.style.top = '0';
          starContainer.style.left = '0';
          starContainer.style.width = '100%';
          starContainer.style.height = '100%';
          starContainer.style.pointerEvents = 'none';
          starContainer.style.zIndex = '1';
          starContainer.style.overflow = 'hidden';
  
          const sizes = [1, 1, 2, 3, 4];
  
          // Get random position between min and max (excluding edges)
          function randomPosition(min, max) {
            return Math.floor(Math.random() * (max - min + 1)) + min;
          }
  
          // Generate 100 stars (avoid edges - use 2% to 98% to prevent border stars)
          for (let i = 0; i < 100; i++) {
            const top = randomPosition(2, 98);
            const left = randomPosition(2, 98);
            const random = Math.floor(Math.random() * sizes.length);
            const randomSize = sizes[random];
  
            const div = document.createElement('div');
            div.style.position = 'absolute';
            div.style.top = top + '%';
            div.style.left = left + '%';
            div.style.height = randomSize + 'px';
            div.style.width = randomSize + 'px';
            div.style.backgroundColor = '#FFFFFF';
            div.style.borderRadius = '50%';
            div.style.pointerEvents = 'none';
  
            // Assign star classes based on index (distributed across 6 animation groups)
            if (i <= 16) {
              div.classList.add('star1');
            } else if (i <= 33) {
              div.classList.add('star2');
            } else if (i <= 50) {
              div.classList.add('star3');
            } else if (i <= 66) {
              div.classList.add('star4');
            } else if (i <= 83) {
              div.classList.add('star5');
            } else {
              div.classList.add('star6');
            }
  
            starContainer.appendChild(div);
          }
  
          // Append the star container as the first child to avoid Slick manipulation
          hero.insertBefore(starContainer, hero.firstChild);
        });
      }
    }
  };

})(Drupal, once);